<template>
  <div class="basic-setting-content pl16 pr16">
    <el-form size="small" ref="form" :model="form" label-width="80px">
      <!--商品详情-->
      <div class="common-form">内容编辑</div>
      <el-form-item label="标题" prop="store_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.title" placeholder="请输入标题" class="max-w460"></el-input>
      </el-form-item>
      <!--内容-->
      <el-form-item label="内容：">
        <div class="edit_container">
          <Uediter v-if="!loading" :text="form.content" :config="ueditor.config"  @contentChange="contentChangeFunc"></Uediter>
        </div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import Uediter from '@/components/UE.vue';
import StoreApi from '@/api/store.js';
export default {
  components: {
    /*编辑器*/
    Uediter,
  },
  data() {
    return {
      loading: true,
      /*富文本框配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 800,
          initialFrameHeight: 500
        },
      },
      is_upload: false,
      config: {
        total: 9,file_type: 'image',
      },
      form:{
        id:0,
        /*商品名称*/
        title: '',
        /*商品详情内容*/
        content: '',
      }
    };
  },
  created() {
    // this.form.id =this.$route.query.id;
    this.getData();
    
  },
  // inject: ['form'],
  methods:{
    /*修改*/
      onSubmit() {
        
        let self = this;
        let form = self.form;
        self.loading = true;
        StoreApi.agreementEdit(form, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，修改成功',
              type: 'success'
            });
            self.$router.push('/appsetting/agree/index');
          }).catch(error => {
            self.loading = false;
          });
        
        // self.$refs.form.validate((valid) => {
        //   if (valid) {
            
        //   }
        // });
      },
      /*获取参数*/
      getData() {
        let self = this;
        self.form.id = self.$route.query.id;
        StoreApi.agreement({
            id: self.form.id
          }, true)
          .then(res => {
            self.form.title = res.data.list[0].title;
            self.form.content = res.data.list[0].content;
            self.loading = false;
          })
          .catch(error => {

          });

      },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    /*获取富文本框内容*/
    // getContent: function() {
    //   return this.$refs.ue.getData();
    // },
    /*获取富文本内容*/
    contentChangeFunc(e){
      console.log(e)
      this.form.content=e;
    },
    openUpload(){
      this.is_upload = true;
    },
    /*上传商品图片*/
    returnImgsFunc(e) {
      if (e != null) {
        let imgs = this.form.model.contentImage.concat(e);
        this.$set(this.form.model, 'contentImage', imgs);
      }
      this.is_upload = false;
    },
    /*删除商品图片*/
    deleteImg(index) {
      this.form.model.contentImage.splice(index, 1);
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/appsetting/agree/edit.vue